const ComponentLoader = () => {
    return (
        <div className="compose-loader loading-white">
            <div className="compose-loader-inn">
                <div className="loading-theme"></div>
            </div>
        </div>
    );
}

export default ComponentLoader;
